import {gql} from '@apollo/client';
import {STAFF_DETAILS} from '../../graphql/fragments';
import {LOGGED_IN_USER_FRAGMENT} from '../../hooks/useDjango';

export const ALL_USERS = gql`
  ${STAFF_DETAILS}

  query GetAllStaff(
    $everything: Boolean
    $search: String
    $businessUnitIds: [UUID!]
    $permissionOverride: Boolean
    $permission: UserPermissionEnum
    $group: PermGroupsEnum
  ) {
    allStaff(
      everything: $everything
      search: $search
      businessUnitIds: $businessUnitIds
      permissionOverride: $permissionOverride
      permission: $permission
      group: $group
    ) {
      ...StaffDetails
    }
  }
`;

export const DEFAULT_PERMISSIONS = gql`
  mutation GetDefaultPermissions($staffId: UUID!) {
    removePermissionOverrides(staffId: $staffId) {
      ok
      errors
      staff {
        ...LoggedInUser
      }
    }
  }
  ${LOGGED_IN_USER_FRAGMENT}
`;

export const CHANGE_USER_GROUP = gql`
  mutation ChangeUserGroup($group: PermGroupsEnum!, $staffId: UUID!) {
    changeUserGroup(staffId: $staffId, group: $group) {
      ok
      errors
      staff {
        ...LoggedInUser
      }
    }
  }
  ${LOGGED_IN_USER_FRAGMENT}
`;

export const UPDATE_USER_PERMISSIONS = gql`
  mutation UpdateUserPermissions($permissions: [UserPermissionEnum]!, $staffId: UUID!) {
    modifyUserPermissions(staffId: $staffId, permissions: $permissions) {
      ok
      errors
    }
  }
`;

export const GET_STAFF_DATA = gql`
  ${STAFF_DETAILS}

  query GetStaffData($staffId: UUID) {
    staff(staffId: $staffId) {
      ...StaffDetails
    }
  }
`;
